import React from 'react';
import cx from 'classnames';
import styles from './ConnectorSettings.module.scss';
import { Link, useRouteMatch } from 'react-router-dom';

function ServiceCard({ service }) {
  const match = useRouteMatch();

  return (
    <Link
      to={`${match.url}/${service.id}`}
      className={cx(styles['service-card'], styles['service-link'])}
    >
      <span className={styles['service-card-icon']}>
        <img src={service.logo} alt={service.name} />
      </span>
      <span className={styles['service-card-title']}>{service.name}</span>
      <span className={styles['service-card-description']}>
        {service.description}
      </span>
    </Link>
  );
}

export default ServiceCard;
